import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-back-circle',
  templateUrl: './icon-back-circle.component.html',
  styleUrls: ['./icon-back-circle.component.scss']
})
export class IconBackCircleComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
